import { css } from 'lit';
export default css `
    :host {
        --collapsible-max-height: none;

        display: block;
        overflow: hidden;
        max-height: var(--collapsible-max-height);
        transition: max-height var(--transition-speed) var(--ease-in-out-quart);
    }
`;
